/**
 * Action / actor / street types — per /design/specs/5_game_engine_spec.md §1.
 *
 * `total` semantics for bet/raise: the total this-street investment of the
 * actor AFTER the action. So a bet of 30 chips into a 0-investedThisStreet
 * position is `{ kind: 'bet', total: 30 }`. Subsequent raise to 90 is
 * `{ kind: 'raise', total: 90 }`. Call and allin derive their chip amounts
 * from the state (no `total` needed).
 */

export type Street = 'preflop' | 'flop' | 'turn' | 'river';

export type Actor = 'hero' | 'villain';

export type PlayerAction =
  | { kind: 'fold' }
  | { kind: 'check' }
  | { kind: 'call' }
  | { kind: 'bet'; total: number }
  | { kind: 'raise'; total: number }
  | { kind: 'allin' };

export type ActionKind = PlayerAction['kind'];

export const STREETS: readonly Street[] = ['preflop', 'flop', 'turn', 'river'];

/** Next street after `current`, or null if `current` is the river. */
export function nextStreet(current: Street): Street | null {
  const idx = STREETS.indexOf(current);
  if (idx < 0 || idx === STREETS.length - 1) return null;
  return STREETS[idx + 1]!;
}

/** Opposite actor — hero ↔ villain. */
export function opposingActor(actor: Actor): Actor {
  return actor === 'hero' ? 'villain' : 'hero';
}
